import { To, resolvePath } from "react-router-dom"

/**
 * Extracts query parameters that start with 'jam-' from a search string.
 * @param searchString The search string (e.g. window.location.search)
 * @returns URLSearchParams containing only jam- parameters
 */
export const getJamQueryParams = (searchString: string): URLSearchParams => {
  const searchParams = new URLSearchParams(searchString)
  const jamParams = new URLSearchParams()
  searchParams.forEach((value, key) => {
    if (key.startsWith("jam-")) {
      jamParams.set(key, value)
    }
  })
  return jamParams
}

/**
 * Appends 'jam-' query parameters from the current location to a target location.
 * @param to The target location (string or PartialPath)
 * @param currentSearchString The current location's search string
 * @returns The updated target location
 */
export const appendJamParams = (to: To, currentSearchString: string): To => {
  const jamParams = getJamQueryParams(currentSearchString)

  if (Array.from(jamParams).length === 0) {
    return to
  }

  const { pathname, search, hash } = resolvePath(to)
  const newSearchParams = new URLSearchParams(search)

  jamParams.forEach((value, key) => {
    newSearchParams.set(key, value)
  })

  // Reconstruct the path
  const newSearch = newSearchParams.toString()
  const searchString = newSearch ? `?${newSearch}` : ""

  return {
    pathname,
    search: searchString,
    hash,
  }
}
